import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { PageDataPanelComponent } from '../../../../shared/page-layout/page-data-panel.component';
import { PageHeroComponent } from '../../../../shared/page-layout/page-hero.component';
import { PageShellComponent } from '../../../../shared/page-layout/page-shell.component';
import { app_permissions } from '../../../../security/app-permissions';
import { PermissionService } from '../../../../security/permission.service';
import { SessionStorageService } from '../../../../services/session-storage.service';
import { RentalAgreement } from '../../rental.model';
import { RentalService } from '../../rental.service';

@Component({
    selector: 'app-rental-agreement-list',
    standalone: true,
    templateUrl: './rental-agreement-list.component.html',
    styleUrls: ['./rental-agreement-list.component.css'],
    imports: [CommonModule, FormsModule, ButtonModule, IftaLabelModule, InputGroupAddonModule, InputGroupModule, InputTextModule, SelectModule, TableModule, TagModule, ToastModule, PageShellComponent, PageHeroComponent, PageDataPanelComponent],
    providers: [MessageService]
})
export class RentalAgreementListComponent implements OnInit {
    agreements: RentalAgreement[] = [];
    loading = false;
    filterStatus = '';
    searchTerm = '';
    readonly canManage: boolean;
    readonly statusOptions = [
        { label: 'All statuses', value: '' },
        { label: 'Draft', value: 'DRAFT' },
        { label: 'Active', value: 'ACTIVE' },
        { label: 'Suspended', value: 'SUSPENDED' }
    ];

    constructor(private rentalService: RentalService, private session: SessionStorageService, private permissions: PermissionService, private router: Router, private messages: MessageService) {
        this.canManage = permissions.hasPermission(app_permissions.fleet.rental.manage);
    }

    ngOnInit(): void { this.load(); }

    load(): void {
        const companyId = this.companyId();
        if (!companyId) return;
        this.loading = true;
        this.rentalService.searchAgreements(companyId, this.filterStatus, this.searchTerm.trim() || undefined).subscribe({
            next: response => { this.agreements = response.items ?? []; this.loading = false; },
            error: error => { this.loading = false; this.messages.add({ severity: 'error', summary: 'Rental', detail: error?.error?.message || 'Could not load rental agreements.' }); }
        });
    }

    open(agreement: RentalAgreement): void { if (agreement.rentalAgreementId) this.router.navigate(['/fleet/rentals/agreements', agreement.rentalAgreementId]); }
    create(): void { this.router.navigate(['/fleet/rentals/agreements/new']); }
    statusSeverity(status?: string): 'success' | 'info' | 'warning' | 'danger' | 'secondary' { return status === 'ACTIVE' ? 'success' : status === 'DRAFT' ? 'info' : status === 'SUSPENDED' ? 'warning' : 'secondary'; }
    private companyId(): number { return this.session.getCompany()?.id ?? 0; }
}
